/**
 * @class Engraving
 * @description Class to manipule modal Engraving.
 */
export class Engraving {
  /**
   * @method constructor
   * @description Only use to call method init for set props and events to elements html
   */
  constructor(container, btnOptions, characters, input, btnForm) {
    this.engravingContainer = document.querySelectorAll(container);
    this.engravingbtns = document.querySelectorAll(btnOptions);
    this.charactersKeyboard = document.querySelectorAll(characters);
    this.inputWrite = document.querySelector(input);
    this.btnFormEngraving = document.querySelector(btnForm);
    this.price, this.title, this.variant;

    this.init();
  }

  /**
   * @method init
   * @description Call method handleItems to manipule the interaction with users
   */

  init() {
    this.engravingContainer && this.handleEngraving(this.engravingContainer);
    this.charactersKeyboard && this.handleKeyboard(this.charactersKeyboard);
    this.btnFormEngraving && this.addSectionEngraving(this.btnFormEngraving);
    this.inputWrite && this.handleTextEngraving(this.inputWrite);
  }

  /**
   * @method unicodeLength
   * @description Take value of input and return a size
   *
   * @param {*} charactersKeyboard
   */

  unicodeLength() {
    const str = this.inputWrite.value;
    let segmenter, segmented;
    if (Intl.Segmenter) {
      segmenter = new Intl.Segmenter('en', {
        granularity: 'grapheme',
      });
      segmented = Array.from(segmenter.segment(str), (s) => s.segment);
    } else {
      segmented = [...str];
    }

    return segmented.length;
  }

  /**
   * @method handleKeyboard
   * @description Capture HTML Collection and then set events
   * to manipule the change visibility of variantios of each product
   *
   * @param {*} charactersKeyboard
   */

  handleKeyboard(charactersKeyboard) {
    let maxCharacter = document.getElementById(
      'engraving-characters-max-render'
    )?.value;

    if (charactersKeyboard) {
      charactersKeyboard.forEach((element) => {
        element.addEventListener('click', () => {
          if (this.unicodeLength() + 1 <= maxCharacter)
            this.inputWrite.value += element.innerText;
          if (
            this.inputWrite.value.length &&
            this.flagSelectedEngraving(this.engravingbtns)
          ) {
            this.btnFormEngraving.disabled = false;
          }
          this.evaluatedValueInput();
        });
      });
    }
  }

  /**
   * @method handleTextEngraving
   * @description Capture value of input engraving, received el input
   * validated if is posible add of chracters
   * @param {*} inputEngraving
   */

  handleTextEngraving(inputEngraving) {
    let characters = document.getElementById('engraving-characters')?.value;
    let maxCharacter = document.getElementById(
      'engraving-characters-max-render'
    )?.value;
    function checkInputChars(e, val, unicode) {
      let dataArray = [...characters];
      let characterUtil = e.data && [...e.data].pop();

      let findCharacter;
      let sizeScreen;
      if (e.isComposing && screen.width < 720) {
        findCharacter = dataArray.find((element) => element === characterUtil);
        sizeScreen = true;
      } else {
        findCharacter = dataArray.find((element) => element === e.data);
        sizeScreen = false;
      }

      if ((!findCharacter && val) || unicode > maxCharacter) {
        let valueInput = [...inputEngraving.value];
        let emoticon = [...val];

        if (sizeScreen) {
          valueInput.splice(valueInput.length - 1);
        } else {
          valueInput.splice(valueInput.length - emoticon.length);
        }

        inputEngraving.value = valueInput.join('');
      }
    }
    inputEngraving.addEventListener('input', (e) => {
      if (e.inputType === 'insertFromPaste') {
        checkInputChars(e, e.target.value, this.unicodeLength());
      } else {
        checkInputChars(e, e.data, this.unicodeLength());
      }
      let valuInput = [...inputEngraving.value];

      const result = valuInput.find((character) => character != ' ');

      /* if (this.unicodeLength() && this.flagSelectedEngraving(this.engravingbtns) && result) {
        this.btnFormEngraving.disabled = false;
      } else {
        this.btnFormEngraving.disabled = true;
      } */
      this.evaluatedValueInput();
    });
  }

  /**
   * @method handleEngraving
   * @description Capture HTML Modal Engraving and then set events
   * to manipule the change variantios of each product
   *
   * @param {*} engravingContainer
   */

  handleEngraving(engravingContainer) {
    if (engravingContainer) {
      const priceEngraving = document.getElementById('engraving-price');
      engravingContainer.forEach((element) => {
        const buttonEngraving = element.querySelector('button');
        buttonEngraving.addEventListener('click', () => {
          this.resetSelectedEngraving(this.engravingbtns);
          buttonEngraving.classList.add('active');
          priceEngraving.innerHTML = buttonEngraving.dataset.price;
          this.price = buttonEngraving.dataset.price;
          this.title = buttonEngraving.dataset.title;
          this.variant = buttonEngraving.dataset.variant;
          this.btnFormEngraving.dataset.id = buttonEngraving.dataset.variant;

          let valuInput = [...this.inputWrite.value];

          const result = valuInput.find((character) => character != ' ');
          if (
            this.inputWrite.value.length &&
            this.flagSelectedEngraving(this.engravingbtns) &&
            result
          ) {
            this.btnFormEngraving.disabled = false;
          }
        });
      });
    }
  }

  /**
   * @method evaluatedValueInput
   * @description Evaluated value of input of engrving
   *
   * @param {*} evaluatedValueInput
   */

  evaluatedValueInput() {
    const modalEngravingError = document.querySelector(
      '.modal-engraving__form-error'
    );
    if (this.inputWrite.value.length) {
      modalEngravingError.classList.add('visibility-none');
    } else {
      modalEngravingError.classList.remove('visibility-none');
    }
  }

  /**
   * @method resetSelectedEngraving
   * @description remove active items engraving when the user change variant
   *
   * @param {*} engravingbtns
   */
  resetSelectedEngraving(engravingbtns) {
    for (let i = 0; i < engravingbtns.length; i++) {
      engravingbtns[i].classList.remove('active');
    }
  }

  /**
   * @method flagSelectedEngraving
   * @description is a flag evaluated if engraving already has been selected
   *
   * @param {*} engravingbtns
   */

  flagSelectedEngraving(engravingbtns) {
    for (let i = 0; i < engravingbtns.length; i++) {
      if (engravingbtns[i].classList.contains('active')) {
        return true;
      }
    }
    return false;
  }

  /**
   * @method dataUtil
   * @description preparates data for send products to cart
   * recived text wrote by the user and ids of products ingraveds
   *
   * @param {*} engraving
   * @param {*} ids
   */

  dataUtil(ids = [], engraving = '', titleOtp = '') {
    const cartParams = {
      items: [],
    };

    let idEngraving;

    for (let i = 0; i < ids.length; i++) {
      if (ids[i]) {
        idEngraving += `-${ids[i]}`;
      }
    }

    let spacesBlack = engraving.replace(/[^a-zA-Z0-9]/g, '');
    spacesBlack.split(/\s+/).join('');

    idEngraving += `-${spacesBlack}`;

    for (i = 0; i < ids.length; i++) {
      let obj = {
        id: ids[i],
        quantity: 1,
        properties: {
          _engraving: true,
          _idEngraving: idEngraving,
        },
      };

      if (i === 0) {
        obj.properties['Info engraving'] = engraving;
        obj.properties['Font type'] = this.title;
        obj.properties['Base Product'] = titleOtp;
      } else {
        obj.properties['_otp_engraving'] = true;
        obj.properties['_Info engraving'] = engraving;
        obj.properties['_Font type'] = this.title;
      }
      cartParams.items.push(obj);
    }

    return cartParams;
  }

  /**
   * @method addSectionModal
   * @description add products to cart
   *
   * @param {*} btnFormEngraving
   */

  addSectionEngraving(btnFormEngraving) {
    const sectionEngraving = document.querySelector('.product-engraving');
    const priceEngravingSelected = document.getElementById(
      'price-engraving-selected'
    );
    const infoEngraving = document.getElementById('info-engraving');
    const fonType = document.getElementById('font-type');
    const engravingChecked = document.getElementById('engraving-blank');
    const inputForm = document.querySelector('.modal-engraving__form--input');
    const modal = document.getElementById('modal-engraving');
    const inputLetters = document.querySelectorAll(
      '.modal-engraving__form-variants_container__option-button '
    );

    this.activeForm(inputLetters, inputForm);

    btnFormEngraving.addEventListener('click', () => {
      if (engravingChecked.checked) {
        this.addEngravingCar();
        this.removeSectionEngraving(sectionEngraving);
        this.upadateAddToCartBtn();
        return;
      }

      if (inputForm.value.length !== 0 && this.checkFont(inputLetters)) {
        sectionEngraving.classList.remove('hidden');
        sectionEngraving.dataset.variant_engraving = this.variant;
        priceEngravingSelected.innerHTML = this.price;
        infoEngraving.innerHTML = this.inputWrite.value;
        fonType.innerHTML = this.title;

        this.addEngravingCar();
        this.upadateAddToCartBtn();
      } else if (inputForm.value.length === 0) {
        const inputFormError = document.querySelector(
          '.modal-engraving__form-error'
        );

        modal.classList.add('active');
        inputFormError.classList.remove('visibility-none');
      } else if (this.checkFont(inputLetters) === false) {
        const inputInputError = document.querySelector(
          '.modal-engraving__button-error'
        );

        modal.classList.add('active');
        inputInputError.classList.remove('visibility-none');
      }
    });
  }

  /**
   * @method checkFont
   * @description Validate if the input text if fill.
   *
   * @param {nodo} inputLetters
   */

  checkFont(inputLetters) {
    let field = false;

    inputLetters.forEach((element) => {
      if (element.classList.contains('active')) {
        field = true;
      }
    });
    return field;
  }

  /**
   * @method activeForm
   * @description Active the form in the engaving if check is selected
   *
   * @param {nodo} inputLetters
   * @param {nodo} inputForm
   */

  activeForm(inputLetters, inputForm) {
    const inputToggle = document.querySelectorAll('.engraving-form__input');
    const formInput = document.querySelector('.modal-engraving__form');

    inputToggle.forEach((element) => {
      element.addEventListener('change', (e) => {
        if (e.target.id === 'engraving-blank') {
          formInput.classList.add('opacity-inactive');
          this.toggleInput(inputLetters, inputForm, true);
        } else {
          formInput.classList.remove('opacity-inactive');
          this.toggleInput(inputLetters, inputForm, false);
        }
      });
    });
  }

  /**
   * @method toggleInput
   * @description able or disable the inputs form in the engaving
   *
   * @param {nodo} inputLetters
   * @param {nodo} inputForm
   * @param {boolean} value
   */

  toggleInput(inputLetters, inputForm, value) {
    inputForm.disabled = value;

    inputLetters.forEach((element) => {
      element.disabled = value;
    });
  }

  /**
   * @method addEngravingCar
   * @description add products to cart the product ingarving and the product OTP that will have engraving
   *
   * @param {*} btnFormEngraving
   */

  addEngravingCar() {
    let dataUtil;
    let idProductOtp = document.querySelector(
      '.variants input[name="id"]'
    )?.value;
    const accesoriesCheckbox = document.querySelector('.accesories_checkbox');
    const optionsOtp = document.querySelector('.variants--select-tag');
    let titleOtp = optionsOtp?.options[optionsOtp.selectedIndex].dataset.title;

    if (accesoriesCheckbox) {
      const idAccesory = accesoriesCheckbox.dataset.accesoryId;
      titleOtp = accesoriesCheckbox.dataset.accesoryTitle;

      console.log([this.btnFormEngraving.dataset.id, idAccesory, idProductOtp]);

      dataUtil = this.dataUtil(
        [this.btnFormEngraving.dataset.id, idAccesory, idProductOtp],
        this.inputWrite.value,
        titleOtp
      );

      localStorage.setItem('engraving', JSON.stringify(dataUtil));
      return;
    }

    dataUtil = this.dataUtil(
      [this.btnFormEngraving.dataset.id, idProductOtp],
      this.inputWrite.value,
      titleOtp
    );
    localStorage.setItem('engraving', JSON.stringify(dataUtil));
  }

  /**
   * @method removeSectionEngraving
   * @description remove engraving selected
   *
   */

  removeSectionEngraving(sectionEngraving) {
    /* const accesoriesCheckbox = document.querySelectorAll(
      '.accesories_checkbox'
    ); */

    sectionEngraving.classList.add('hidden');
    delete sectionEngraving.dataset.variant_engraving;

    /* if (accesoriesCheckbox.length !== 0) {
      accesoriesCheckbox[0].dataset.accesoryId =
        accesoriesCheckbox[0].dataset.accesoryIdEngraving;
    } */
  }

  /**
   * @method upadateAddToCartBtn
   * @description Update the botton personalize to add to cart
   *
   */

  upadateAddToCartBtn() {
    /* const buttonOpenModal = document.querySelectorAll(
      '.engraving.engraving--accesory'
    ); */
    const buttonAddCart = document.querySelectorAll(
      '.product__description--variantform-btn'
    );

    /* buttonOpenModal.forEach((element) => {
      element.classList.add('hidden');
    }); */

    buttonAddCart.forEach((element) => {
      element.disabled = false;
    });

    buttonAddCart[0].click();

    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
